import React, { Component } from 'react';
import Box from '@mui/material/Box';

import { Divider, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { FeatureGroup, MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { FeatureLayer } from "react-esri-leaflet";
import MapDialog from './MapDialog';

const DEFAULT_THAILAND_POSITION = [13.736717, 100.523186]
const DEFAULT_ZOOM = 6
const FEATURE_LAYER_URL = 'https://services1.arcgis.com/jSaRWj2TDlcN1zOC/ArcGIS/rest/services/Thailand_Subdistrict_Boundaries_2022/FeatureServer/8'

class MapAIML extends Component {

  constructor(props) {
    super(props)
    this.mapRef = React.createRef()
    this.markerRef = React.createRef()
    this.state = {
      filter: {},
      filteredStation: [],
      stations: [],
      area: [],
      selectedArea: {province: null, amphoe: null, tambon: null},
      isModalOpen: false,
      zoomLevel: 9,
    }
    this.initdata()
  }

  initdata() {
    this.setState({
      filter: this.props.filter,
      area: this.props.areaData,
      stations: this.props.stations,
      isModalOpen: false,
    })
    this.filterStation()

  }
  async componentDidMount() {
    this.filterStation()
    await this.setState({
      area: this.props.areaData,
      filter: this.props.filter,
      stations: this.props.stations,
      isModalOpen: false,
    })
    // this.mapRef.current.fitBounds([[17.759, 99.93], [16.79, 99.385]]) //สุโขทัย
    this.mapRef.current.fitBounds([[19.856740,98.540013], [18.304581,99.144664]])
    // this.mapRef.current.fitBounds([[19.759, 98.93], [17.42, 98.885]])
    this.zoomToMarkers()
    this.mapRef.current.on('zoomend', this.handleZoomEnd)
  }

  async componentDidUpdate(pP, pS) {
    if(pS.stations.length===0 && this.props.stations.length!==0) {
      await this.setState({stations: this.props.stations})
    }
    if(this.props.filter.dwr_region !== pS.filter.dwr_region||
        this.props.filter.dopa_region !== pS.filter.dopa_region||
        this.props.filter.province !== pS.filter.province ||
        this.props.filter.amphoe !== pS.filter.amphoe ||
        this.props.filter.tambon !== pS.filter.tambon ) {
      await this.setState({
        filter: this.props.filter,
        stations: this.props.stations,
      })
      await this.filterStation()
    }
    if(pS.filteredStation !== this.state.filteredStation) {
      this.zoomToMarkers()
    }
  }

  filterStation = async () => {
    let filter = this.state.filter
    let filteredStation = this.state.stations
    if(filter.dwr_region!==null) {filteredStation = filteredStation.filter(d=>d.dwr_region===filter.dwr_region)}
    if(filter.dopa_region!==null) {filteredStation = filteredStation.filter(d=>d.dopa_region===filter.dopa_region)}
    if(filter.province!==null) {filteredStation = filteredStation.filter(d=>d.province===filter.province)}
    if(filter.amphoe!==null) {filteredStation = filteredStation.filter(d=>d.amphoe===filter.amphoe)}
    if(filter.tambon!==null) {filteredStation = filteredStation.filter(d=>d.tambon===filter.tambon)}
    await this.setState({filteredStation:filteredStation})
    this.zoomToMarkers();
  }

  async setSelectedArea(selected) {
    await this.setState({selectedArea:selected})
  }

  async _onFeatureClick(f) {
    let province = f.properties.NAME1
    let amphoe = f.properties.NAME2
    let tambon = f.properties.NAME3
    this.setSelectedArea({province, amphoe, tambon})
    await this.setState({isModalOpen: true})
    // alert(`${this.state.isModalOpen}`)

  }

  zoomToMarkers = () => {
    try {
      let map = this.mapRef.current
      let markers = this.markerRef.current
      map.fitBounds(markers.getBounds())
    } catch(e) { }
  }

  onCloseModal = async () => {
    await this.setState({
      isModalOpen: false,
      selectedArea: {province: null, amphoe: null, tambon: null},
    })
  }

  handleZoomEnd = async (e) => {
    let zoomLevel = e.target.getZoom()
    await this.setState({
      zoomLevel
    })
    let markers = this.markerRef.current._layers
    for (const [key, marker] of Object.entries(markers)) {
      let icon = marker.options.icon
      let sizeW = 0 + (zoomLevel * 2.25)
      let sizeH = (zoomLevel*0.7) + (zoomLevel * 2.5)
      icon.options.iconSize = [sizeW, sizeH];
      icon.options.shadowSize = [0,0];
      icon.options.iconAnchor = [0,0];
      marker.setIcon(icon)
    }
  }

  render() {
    return (
      <Box className="aiml-map" sx={{height: '100%', p:2}}>
        <MapContainer 
          center={this.props.position || DEFAULT_THAILAND_POSITION} 
          zoom={this.props.zoom || DEFAULT_ZOOM} 
          scrollWheelZoom={true}
          whenCreated={ mapInstance => { this.mapRef.current = mapInstance } }
        >

          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <FeatureGroup ref={this.markerRef}>
          { (this.state.filteredStation.length > 0 || this.state.filteredStation!==null) &&
            this.state.filteredStation.filter(d=>d.latitude!==null&&d.longitude!=null).map(o => {
              let lat = o.latitude
              let lng = o.longitude
              if(lat>lng) {
                lat = o.longitude
                lng = o.latitude
              }

              return (
              <Marker position={[lat, lng]} color={'red'} key={o.stn_cover+o.name}>
                <Popup>
                  <Typography variant='h6'>{o.stn} {o.name}</Typography>
                  <Typography variant='subtitle1' >ข้อมูล ณ วันที่ {o.stn_date}</Typography>
                  <Divider></Divider>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 50 }} size="small" aria-label="simple table">
                      <TableBody>
                        <TableRow>
                          <TableCell>ระดับน้ำ</TableCell>
                          <TableCell>{o.wl07h}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>น้ำฝน</TableCell>
                          <TableCell>{o.rain07h}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>ความชื้นในดิน</TableCell>
                          <TableCell>{o.soil107h}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>อุณหภูมิ</TableCell>
                          <TableCell>{o.temp07h}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Popup>
              </Marker>
            )})
          }
          </FeatureGroup>

          <FeatureLayer url={FEATURE_LAYER_URL} style={(f) => {
            let province = f.properties.NAME1
            let amphoe = f.properties.NAME2
            let tambon = f.properties.NAME3
            let style = {
              width: 0.2,
              opacity: 1,
              fillOpacity: 0.2,
              color: 'black'
            }

            if((this.state.filter.province!==null && this.state.filter.province!==province) ||
                (this.state.filter.amphoe!==null && this.state.filter.amphoe!==amphoe) ||
                (this.state.filter.tambon!==null && this.state.filter.tambon!==tambon)
            ) {
              style.opacity = 0
              style.fillOpacity = 0
            }
            let match = this.state.area.find((o, i) => {
              return o.province===province  && 
                o.amphoe===amphoe && 
                o.tambon===tambon
            })
            if(match !== null && typeof(match) !== "undefined") {
              if(match.level===1) { style.color = 'red' }
              else if(match.level===2) { style.color = 'orange' }
              else if(match.level===3) { style.color = 'green' }
              else if(match.level===4) { style.color = 'yellow' }
              else if(match.level===5) { style.color = 'blue' }
              else {style.color = 'black' }
            }
            return (style)
          }} onEachFeature={(f, l) => {
            l.on({click: () => {this._onFeatureClick(f)}})
            // let province = f.properties.NAME1
            // let amphoe = f.properties.NAME2
            // let tambon = f.properties.NAME3

            // if(
            //     (
            //       (
            //         this.state.filter.province!==null && 
            //         typeof this.state.filter.province !== 'undefined' && 
            //         this.state.filter.province===province
            //       ) ||
            //       (
            //         this.state.filter.amphoe!==null && 
            //         typeof this.state.filter.amphoe !== 'undefined' && 
            //         this.state.filter.amphoe===amphoe
            //       ) ||
            //       (
            //         this.state.filter.tambon!==null && 
            //         typeof this.state.filter.tambon !== 'undefined' && 
            //         this.state.filter.tambon===tambon
            //       )
            //     ) ||
            //     (this.state.filter.province!==null&&this.state.filter.amphoe!==null&&this.state.filter.tambon!==null)
            //   )
            // {
            //   console.log('f1', this.state.filter.province, province)
            //   console.log('f1', this.state.filter.amphoe, amphoe)
            //   console.log('f1', this.state.filter.tambon, tambon)
            //   l.on({click: () => {this._onFeatureClick(f)}})
            // }

          }} />
        </MapContainer>
        {
          (this.state.isModalOpen && this.state.selectedArea !== null) &&
          <Box sx={{p:20, m:20}}>
            <MapDialog 
              isModalOpen={this.state.isModalOpen}
              selectedArea={this.state.selectedArea}
              onCloseModal={this.onCloseModal}
            />
          </Box>

        }
      </Box>
    );
  }
}

export default MapAIML;
